import React from 'react';
import PostJobTable from '../Jobs/PostedJobsandAppliedCandidates/PostJobTable';

const SubUsers = () => {

    let headers = ["Name", "Email", "Created on"];
    let columns = ['first_name', 'email', 'date_joined'];

    let addform = [
        { 'type': 'short-text', 'name': 'first_name', 'label': 'First Name', 'placeholder': 'First Name' },
        { 'type': 'short-text', 'name': 'username', 'label': 'Username', 'placeholder': 'Username' },
        { 'type': 'short-text', 'name': 'email', 'label': 'Email', 'placeholder': 'Email' }
    ]

    return (
        <PostJobTable
            title="Users"
            header={headers}
            url="user/emp-subuser/"
            column={columns}
            addform={addform}
            subuser="user/emp-subuser/"
        />
    );
};

export default SubUsers;